import { Routes } from '@angular/router';
import { SearchMainComponent } from './search-main/search-main.component';
import { SearchErrorComponent } from './search-error/search-error.component';
import { environment } from '../environments/environment';

export const routes: Routes = [
  { path: '', redirectTo: environment.production ? 'en/search.html' : 'en/search', pathMatch: 'full' },
  { path: 'search', redirectTo: 'en/search.html' },
  { path: 'site-search/:localeGroup/search.html', component: SearchMainComponent },
  { path: environment.production ? ':localeGroup/search.html' : ':localeGroup/search', component: SearchMainComponent },
  {
    path: environment.production ? ':localeGroup/search/error.html' : 'localeGroup/search/error',
    component: SearchErrorComponent
  }
];
